export const visitIQColumns = 'visitIQ-columnsV11';
export const visitIQTaxonomyFilters = 'visitIQ-taxonomy-filters';
export const visitIQGeoFilters = 'visitIQ-geo-filtersV2';
export const visitIQSettings = 'visitIQ-settings';
export const visitIQAudience = 'visitIQ-audience';
export const visitIQFilterFieldConditions = 'visitIQ-filter-field-conditionsV1';
export const visitIQGoogleAnalytics = 'visitIQ-ga';
